import React from 'react';

import Card from './Card'
import Collage from './Collage'

const variantMaps = {
  Card: Card,
  Collage: Collage
}

const ImageContentBlock = (props) => {  
  const { variant } = props

  let comp
  if (variant in variantMaps)
    comp = variantMaps[variant]
  else
    comp = variantMaps['Card']
  return React.createElement(comp, {
    ...props
    })  
}

export default ImageContentBlock;

